import { serviceArea1, serviceArea2, serviceWarehouse1, serviceWarehouse2 } from './models';
import { companyMap } from '../contact-us/models';

$(function () {
    $(".header-section").addClass("floating");
    // 菜单栏样式
    // $("#navigation .logo").hide();
    // $(".container").removeClass("container_floating");
    // $("#header .container .navbar-left a").show();

    var snapScroller = $("#document").snapScroll({
        onArrive: function (prevPoint, currentPoint) {

        },
        onLeave: function (currentPoint, nextPoint) {
        }
    });

    {
        let selector = `#service-area .divider-section__option`
        const func = (selector: string) => {
            $(selector)
                .on('click', function () {
                    const optionThis = this;
                    const _datasetName = this.dataset.area ? 'data-service-area' : 'data-service-warehouse'
                    $(selector).removeClass('divider-section__option--active')
                    $(this).addClass('divider-section__option--active')
                    console.log(this.dataset.option);
                    const displayMap = {
                        s1: serviceArea1,
                        s2: serviceArea2,
                        h1: serviceWarehouse1,
                        h2: serviceWarehouse2,
                    }
                    const bgImg = {
                        s1: 'images/service/service-area1.png',
                        s2: 'images/service/service-warehouse1.png',
                        h1: 'images/service/service-warehouse1.png',
                        h2: 'images/service/service-warehouse2.png',
                    }
                    $(`.point-container[${_datasetName}] .point-container__item`).remove()
                    /* 设置地图背景图 */
                    if (this.dataset.area) {
                        $(`#service-area-img`).attr('src', bgImg[this.dataset.map])
                    } else {
                        $(`#service-warehouse-img`).attr('src', bgImg[this.dataset.map])
                    }

                    /*  */
                    const mapTemplateList = displayMap[this.dataset.map ].filter(o => o.name).map(o => {
                        return `
                        <div class="point-container__item" data-city="${o.city}" data-name="${o.name}" data-img="${o.img}" style="top:${o.top}%;left: ${o.left}%"><div class="point-container__point"></div></div>
                        `
                    })
                    $(`.point-container[${_datasetName}]`).append(mapTemplateList.join(''))
                    $(`.point-container[${_datasetName}] .point-container__item`)
                        .on('click', function () {
                            $(`.point-container[${_datasetName}] .point-container__item`).removeClass('active')
                            $(this).addClass('active')
                            if (optionThis.dataset.area) {
                                // $(`#service-area-point-img`).css('background-image', `url(${this.dataset.img})`)
                                let arr = []
                                for (const key in companyMap) {
                                    arr = arr.concat(companyMap[key])
                                }
                                const cityData = arr.filter(o => o.name === this.dataset.name)[0]

                                $(`.point-container[${_datasetName}] .contact-company__name`).text($.i18n(`${cityData.name}`))
                                $(`.point-container[${_datasetName}] span[data-phone]`).text(`${cityData.phone}`)
                                $(`.point-container[${_datasetName}] span[data-email]`).text(`${cityData.email}`)
                                $(`.point-container[${_datasetName}] span[data-location]`).text($.i18n(`${cityData.location}`))
                                drawAreaLine('.point-container[data-service-area]', '.contact-company')
                            } else {
                                $(`#service-warehouse-point-img`).css('background-image', `url(${this.dataset.img})`)
                                drawAreaLine('.point-container[data-service-warehouse]', `.point-container__imgv2`)
                                $(`.point-container[${_datasetName}] .point-container__namev2`).text($.i18n(`${this.dataset.name}`))

                                // $(`.point-container[data-service-warehouse] .point-container__namev2`).text($.i18n(warehouseCompany.name));

                            }
                        })
                    setTimeout(() => {
                        $(`.point-container[${_datasetName}]`).i18n();
                        $(`.point-container[${_datasetName}] .point-container__item:first`).trigger('click')
                    }, 20)
                })
        }
        func(`#service-area .divider-section__option`);
        func(`#warehouse-area .divider-section__option`);

        setTimeout(() => {
            $('#service-area .divider-section__option:first')
                .trigger('click');
            $('#warehouse-area .divider-section__option:first')
                .trigger('click');
        })
    }

    $('#to-service-area')
        .on('click', function () {
            (<any>snapScroller).scrollNext();
        })

    setTimeout(() => {
        setContainerSize()
    })

    $(window).on('resize', (window as any)._.debounce(() => {
        setContainerSize();

        $(`.point-container__item.active`).trigger('click')
    }, 300))

    function setContainerSize() {
        $('#service-area .point-container').height($('#service-area-img').outerHeight())
        $('#service-area .point-container').width($('#service-area-img').outerWidth())
        $('#warehouse-area .point-container').height($('#service-warehouse-img').outerHeight())
        $('#warehouse-area .point-container').width($('#service-warehouse-img').outerWidth())
        $('#service-area .point-container').css('left', $(`#service-area-img`).position().left + 'px')
        $('#warehouse-area .point-container').css('left', $('#service-warehouse-img').position().left+ 'px');
    }
});

$(document).on("ready", function () {
    $('body').on("languageChanged", function (lang) {
        const firstCompany=companyMap["south-china"][0];
        $(`.point-container[data-service-area] .contact-company__name`).text($.i18n(firstCompany.name))
        $(`.point-container[data-service-area] span[data-phone]`).text(firstCompany.phone)
        $(`.point-container[data-service-area] span[data-email]`).text(firstCompany.email)
        $(`.point-container[data-service-area] span[data-location]`).text($.i18n(firstCompany.location))
    
        const warehouseCompany=companyMap["north-america"][0];
        $(`.point-container[data-service-warehouse] .point-container__namev2`).text($.i18n(warehouseCompany.name));
      });
   
  });

function drawAreaLine(prefixSelector: string, imgSelector: string) {
    const lineX = $(`${prefixSelector} .point-container__line-x`)
    const lineY = $(`${prefixSelector} .point-container__line-y`)
    const img = $(`${prefixSelector} ${imgSelector}`)
    const item = $(`${prefixSelector} .point-container__item.active`)
    const imgPos = img.position()
    const itemPos = item.position()
    const imgSize = { w: img.outerWidth(), h: img.outerHeight() }
    const itemSize = { w: item.outerWidth(), h: item.outerHeight() }
    const isTop = (imgPos.top + imgSize.h < itemPos.top + itemSize.h);

    /* 判断图片在右边，现在不走这个逻辑了，图片都在左边 */
    if (itemPos.left <= imgPos.left) {
        const lineXX = itemPos.left + itemSize.w;
        const lineXY = itemPos.top + itemSize.h / 2;
        const lineYX = imgPos.left + imgSize.w / 2;
        const lineYY = imgPos.top;

        // console.log(imgPos);
        // console.log(itemPos);
        // console.log(lineXY, lineYX);
        lineX.width(Math.abs(lineXX - lineYX))
        lineX.css('top', lineXY + 'px')
        lineX.css('left', lineXX + 'px')

        lineY.height(Math.abs(lineXY - lineYY))
        lineY.css('top', lineXY + 'px')
        lineY.css('left', lineXX + lineX.width() + 'px')

        if (itemPos.top + itemSize.h >= imgPos.top) {
            lineX.width(imgPos.left - itemPos.left - (itemPos.left <= itemPos.left ? itemSize.w : imgSize.w))
            lineY.height(0)
        }
    } else {
        const lineXX = imgPos.left + imgSize.w / 2;
        const lineXY = itemPos.top + itemSize.h / 2;
        const lineYX = imgPos.left + imgSize.w / 2;
        /* 判断图片在上面下面 */
        const lineYY = isTop ? imgPos.top + imgSize.h : lineXY;

        // console.log(imgPos);
        // console.log(itemPos);
        // console.log(lineXY, lineYX);
        lineX.width(Math.abs(itemPos.left - lineYX))
        lineX.css('top', lineXY + 'px')
        lineX.css('left', lineXX + 'px')

        lineY.height(Math.abs(isTop ? lineXY - lineYY : (lineXY - imgPos.top)))
        lineY.css('top', lineYY + 'px')
        lineY.css('left', lineXX + 'px')

        if (prefixSelector === '.point-container[data-service-area]') {
            if (itemPos.top <= imgPos.top + imgSize.h) {
                lineX.width(itemPos.left - imgPos.left - imgSize.w)
                lineX.css('left', imgPos.left + imgSize.w + 'px')
                lineY.height(0)
            }
        }
    }
}